import {createSelector} from '@reduxjs/toolkit'

export const selectAuth = (state: any) => state.auth

export const selectUser = createSelector(selectAuth, (auth) => auth.user)
export const selectUsers = createSelector(selectAuth, (auth) => auth.users)
export const selectRoles = createSelector(selectAuth, (auth) => auth.roles)
export const selectPermissions = createSelector(selectAuth, (auth) => auth.permissions)
